import { login, getUserInfo } from '../../utils/api';

const TOKEN_KEY = 'fangzhou_token';

const state = {
  token: localStorage.getItem(TOKEN_KEY) || '',
  userInfo: null,
  menus: [],
  permCodes: [],
  userLoaded: false
};

const mutations = {
  SET_TOKEN(state, token) {
    state.token = token;
    if (token) {
      localStorage.setItem(TOKEN_KEY, token);
    } else {
      localStorage.removeItem(TOKEN_KEY);
    }
  },
  SET_USER_INFO(state, payload) {
    state.userInfo = payload.userInfo || null;
    state.menus = payload.menus || [];
    state.permCodes = payload.permCodes || [];
    state.userLoaded = true;
  },
  RESET_USER(state) {
    state.userInfo = null;
    state.menus = [];
    state.permCodes = [];
    state.userLoaded = false;
  }
};

const actions = {
  async login({ commit }, payload) {
    const res = await login(payload);
    if (res && res.code === 0 && res.data) {
      commit('SET_TOKEN', res.data.token);
      commit('SET_USER_INFO', {
        userInfo: res.data.userInfo,
        menus: res.data.menus || [],
        permCodes: res.data.permCodes || []
      });
    }
    return res;
  },
  async fetchUserInfo({ commit }) {
    const res = await getUserInfo();
    if (res && res.code === 0 && res.data) {
      commit('SET_USER_INFO', {
        userInfo: res.data.userInfo,
        menus: res.data.menus || [],
        permCodes: res.data.permCodes || []
      });
    }
    return res;
  },
  async logout({ commit }) {
    commit('SET_TOKEN', '');
    commit('RESET_USER');
  }
};

const getters = {
  token: s => s.token,
  userInfo: s => s.userInfo,
  menus: s => s.menus,
  permCodes: s => s.permCodes,
  userLoaded: s => s.userLoaded
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};

